import axios from 'axios';
import cookies from 'js-cookie';
import store from '@/store';

const api = axios.create({
  baseURL: window.baseURL || process.env.VUE_APP_API_URL || null,
});

api.interceptors.request.use((config) => {
  const partesUrl = window.location.pathname.split('/');
  const addAuthorization = !store.getters.publicPages.includes(partesUrl[1]);
  if (addAuthorization && store.getters.token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${store.getters.token}`;
  }

  return config;
}, error => Promise.reject(error));

function refreshToken() {
  if (store.getters.refreshingTokenPromise) {
    return store.getters.refreshingTokenPromise;
  }

  const refreshingTokenPromise = api.get('refreshToken').then(() => {
    store.dispatch('setRefreshingTokenPromise', undefined);
    return Promise.resolve(true);
  });

  store.dispatch('setRefreshingTokenPromise', refreshingTokenPromise);

  return refreshingTokenPromise;
}

api.interceptors.response.use(
  (response) => {
    if (response.headers && response.headers.authorization) {
      cookies.remove('tokenMatrix');
      store.dispatch('setToken', response.headers.authorization.replace('Bearer ', ''));
      if (response.headers['x-set-user-name']) {
        store.dispatch('setUser', decodeURI(response.headers['x-set-user-name']));
      }
    }
    return response;
  },
  (error) => {
    const urlRefreshToken = `${error.config.baseURL}/refreshToken`.replace('//r', '/r');
    if (
      error.response
      && error.response.status === 403
      && urlRefreshToken !== error.config.url
    ) {
      return refreshToken()
        .then(() => api.request(error.config))
        .catch(() => window.location.assign('/login'));
    }
    return Promise.reject(error);
  },
);

export default api;
